// extracted by mini-css-extract-plugin
export default {"changeCategoryModal":"styles_changeCategoryModal__TECsC","mainTableHeaderWrapper":"styles_mainTableHeaderWrapper__EbN6C","dropdownContainer":"styles_dropdownContainer__D1Dqe"};